
import React, { useEffect, useMemo, useState } from 'react'
import Header from 'units/dashboard/components/Header';
import { SidebarProvider } from 'units/dashboard/context/SidebarProvider';
import { ProgressBar } from 'react-loader-spinner';
import Footer from 'units/dashboard/components/Footer';
import feather from "feather-icons";
import { CheckIcon } from '@heroicons/react/20/solid'
import { useNavigate } from 'react-router-dom'
import AdminSidebar from '../components/AdminSidebar';
import { planList } from './services/PlanServices';
import { useSelector } from 'react-redux';
import { Crown, Star } from 'lucide-react';
import PermissionsModal from "./myPlanModal/PermissionsModal"
import BotsModal from "./myPlanModal/BotsModal"
export const PermCategory = {
  PAGE: "page",
  API: "api",
  AI_MODEL: "ai",
  EMBEDDER: "textEmbder",
  CHART: "analysticChart",
  PLATFORM: "platform",
  TOOL: "ai-tool",
};

const groupPermissionsByCategory = (permissions = []) => {
  return permissions.reduce((acc, item) => {
    if (!item.isAvailable) return acc;

    const category = item.category;

    if (!acc[category]) {
      acc[category] = [];
    }

    acc[category].push({
      id: item.id,
      name: item.name,
      label: item.persianName,
      logo: item.logo,
    });

    return acc;
  }, {});
};


function Plans({ plans }) {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isPermModalOpen, setIsPermModalOpen] = useState(false);
  const [activePermissions, setActivePermissions] = useState({});
  const [isBotsModalOpen, setIsBotsModalOpen] = useState(false);
  const [activeBots, setActiveBots] = useState([]);

  const navigate = useNavigate()
  const handleSelectPlan = (plan) => {
    navigate('/admin/edit-plan'
      , { state: { selectedPlan: plan } }
    )
  };
  const sortedData = useMemo(() => {
    return [...plans].sort(
      (a, b) => new Date(a.tokens) - new Date(b.tokens)
    );
  }, [plans]);
  const CATEGORY_LABELS = {
    analysticChart: " نمودارها",
    ai: " مدل‌های هوش مصنوعی",
    textEmbder: " امبدینگ",
    platform: " پلتفرم شبکه های اجتماعی",
    "ai-tool": " ابزارها",
    page: "دسترسی به صفحات",
  };

  return (
    <div className="relative isolate bg-white px-8 py-12">
      <div className="mx-auto grid max-w grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {sortedData.map((tier) => {
          const permissionsByCategory = tier.permissions
            ? groupPermissionsByCategory(tier.permissions)
            : {};
          return (
            <div
              key={tier.id}
              className={`
  rounded-2xl p-6 shadow-md ring-1 transition-all hover:shadow-xl
  ${tier.isActive
                  ? "bg-green-50 ring-green-500 border-2 border-green-500"
                  : "bg-white ring-gray-200"
                }
  ${!tier.isActive
                  ? "bg-red-50 ring-red-500 border-2 border-red-500"
                  : "bg-white ring-gray-200"
                }
`}
            >
              <div className="flex items-center justify-between ">
                <h3 className="text-[#1B4748] text-xl font-semibold mb-1 text-center flex " id={tier.id}>
                  {tier?.isFeatured && (
                    <div className="relative group ml-2">
                      <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" />
                      {/* تولتیپ */}
                      <span className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs bg-yellow-500 text-white rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                        طرح برگزیده
                      </span>
                    </div>
                  )}
                  {/* <Crown className="w-5 h-5 text-yellow-500 fill-yellow-500 text-center" /> */}

                  {tier.name}
                </h3>
                <div className={` w-[80px] text-center text-white  text-sm font-semibold mb-1 px-4 py-1 rounded-lg ${tier.isActive ? "bg-[#1B4748]" : "bg-[#FFC505]"} `} id={tier.id}>
                  {tier.isActive ? "فعال" : "غیرفعال"}
                </div>
              </div>
              {/* <p className="mt-4 flex items-baseline gap-x-2">
              <span className="text-gray-900 text-lg font-bold">{tier?.price.toLocaleString('fa-IR')} ریال</span>
              <span className="text-gray-500 text-sm">/{tier.duration.toLocaleString('fa-IR')}روز</span>
              {tier?.offPercentage && <span className="text-white px-2 py-1 mr-3  rounded-full bg-red-600 text-sm font-bold">{tier?.offPercentage} %</span>}
            </p> */}

              <div className='flex items-center justify-between gap-x-2'>
                <div className='flex gap-x-2'>
                  <p className="mt-2 flex flex-col items-start gap-y-1">
                    {typeof tier?.offPercentage === 'number' && tier.offPercentage > 0 && (
                      <span className="text-red-600 text-base font-bold">
                        {(tier.price * (1 - tier.offPercentage / 100)).toLocaleString('fa-IR')} ریال
                      </span>

                    )}
                    <span
                      className={`text-lg font-bold ${(typeof tier?.offPercentage === 'number' && tier.offPercentage > 0) ? 'text-gray-400 line-through' : 'text-gray-900 mt-7'
                        }`}
                    >
                      {tier?.price.toLocaleString('fa-IR')} ریال
                    </span>

                  </p>
                  <span className={`text-gray-500 text-sm ${typeof tier?.offPercentage === 'number' && tier.offPercentage > 0 ? "mt-10" : "mt-10"} `}>
                    / {tier?.duration === -1 ? "بینهایت" : tier.duration.toLocaleString('fa-IR')} روز
                  </span>

                </div>
                {typeof tier?.offPercentage === 'number' && tier.offPercentage > 0 && <div className="flex items-center justify-center h-10 text-white text-center p-3 mr-3  rounded-full bg-red-400 text-sm font-bold">%{tier?.offPercentage} </div>}
              </div>
              {/* <p className="mt-4 text-gray-600 text-sm">{tier.description}</p> */}
              <ul role="list" className="mt-6 space-y-3 text-sm text-gray-600">

                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.tokens.toLocaleString('fa-IR')} توکن مصرفی
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.files == -1 ? "بینهایت" : tier.files.toLocaleString('fa-IR')}  فایل بارگذاری شده
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.fileSize == -1 ? "بینهایت" : tier.fileSize.toLocaleString('fa-IR')} مگابایت حجم هر فایل
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.charLimit == -1 ? "بینهایت" : tier.charLimit.toLocaleString('fa-IR')} کاراکتر مصرفی
                </li>
                {/* <li key={tier.fileSize} className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                   {tier.fileSize} عدد لینک سایت 
                </li> */}
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.userLimit.toLocaleString('fa-IR')}  کاربره
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.userTokens.toLocaleString('fa-IR')} محدودیت توکن ارسالی از کاربر
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.gptMaxTokens.toLocaleString('fa-IR')} محدودیت توکن دریافتی به کاربر
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.messagePerDay == -1 ? "بینهایت" : tier.messagePerDay.toLocaleString('fa-IR')}  پیام روزانه (هر ارسال - دریافت)
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.promptTokens.toLocaleString('fa-IR')} توکن برای پرامپت سیستمی
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.fileTokens.toLocaleString('fa-IR')}  توکن برای هر فایل بارگذاری شده
                </li>
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {tier.platformPercent.toLocaleString('fa-IR')}  درصد کارمزد پلتفرم
                </li>
                <li className="flex items-start gap-x-2 flex-row">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {Object.keys(permissionsByCategory).length > 0 ? (
                    <button
                      type="button"
                      onClick={() => {
                        setActivePermissions(permissionsByCategory);
                        setIsPermModalOpen(true);
                      }}
                      className=" text-sm text-[#1B4748] underline hover:text-[#0f2f30]"
                    >
                      دارای امکانات خاص
                    </button>
                  ) :
                    <p>بدون امکانات خاص</p>
                  }
                </li>
                <li className="flex items-start gap-x-2 flex-row">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  {Array.isArray(tier.bots) && tier.bots.length > 0 ? (
                    <button
                      type="button"
                      onClick={() => {
                        setActiveBots(tier.bots);
                        setIsBotsModalOpen(true);
                      }}
                      className=" text-sm text-[#1B4748] underline hover:text-[#0f2f30]"
                    >
                      برای تعدادی بات‌ ({tier.bots.length})
                    </button>
                  )

                    :
                    <p>برای همه ی بات ها</p>
                  }
                </li>

                {/* {tier?.permissions &&
                <li className="flex items-start gap-x-2">
                  <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                  امکانات رایابات
                  <ul role="list" className="mt-6 space-y-3 text-sm text-gray-600">
                    <li className="flex items-start gap-x-2">
                      <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                    </li>
                  </ul>
                </li>
              } */}
                {/* {Object.keys(permissionsByCategory).length > 0 &&
                  Object.entries(permissionsByCategory).map(([category, items]) => {
                    if (!items.length) return null;

                    return (
                      <li key={category} className="mt-4">

                        <p className=" mb-2 flex items-start gap-x-2">
                          <CheckIcon className="h-5 w-5 text-[#aadec5] flex-none" aria-hidden="true" />
                          {CATEGORY_LABELS[category] || category}
                        </p>


                        <ul className="space-y-2 mr-4">
                          {items.map(item => (
                            <li key={item.id} className="flex items-center gap-2">
                              <span>
                                {item.logo}
                              </span>
                              <span>{item.label}</span>
                            </li>
                          ))}
                        </ul>
                      </li>
                    );

                  })} */}


              </ul>
              <button
                onClick={() => handleSelectPlan(tier)}
                aria-describedby={tier.id}
                className=" mt-6 w-full rounded-md bg-[#aadec5] px-4 py-2.5 text-center text-sm font-semibold text-gray-600 hover:bg-[#7ee2b2]"
              >
                ویرایش
              </button>
            </div>
          )
        })}

      </div>
      <PermissionsModal
        isOpen={isPermModalOpen}
        onClose={() => setIsPermModalOpen(false)}
        permissionsByCategory={activePermissions}
        categoryLabels={CATEGORY_LABELS}
      />
      <BotsModal
        isOpen={isBotsModalOpen}
        onClose={() => setIsBotsModalOpen(false)}
        bots={activeBots}
      />

    </div>
  )
}



export default function MyPlans() {
  const [loading, setLoading] = useState(true);
  // const [formData, setFormData] = useState({
  //     id:"",
  //     name: "",
  //     price: "",
  //     duration: "",
  //     tokens: "",
  //     files: "",
  //     fileSize: "",
  //     userLimit: "",
  //     offPercentage: "",
  //     messagePerDay:"",
  //     tokenLimit:"",
  //     userLimit:"",
  //     charLimit:"",
  //     isActive:true,
  //     createdAt:"",
  //     updatedAt:""

  // })
  const [formData, setFormData] = useState([])
  const accessToken = useSelector((state) => state.auth.accessToken);
  useEffect(() => {
    const allPlans = async () => {
      setLoading(true);
      try {
        const res = await planList(accessToken);
        if (res?.ok) {
          setFormData(res?.data);
        }
      } catch (error) {
        console.log("خطا در دریافت اطلاعات:", error);
      } finally {
        setLoading(false); // پس از دریافت اطلاعات، لودینگ را مخفی کن
      }
    };

    allPlans();
  }, [accessToken]);
  useEffect(() => {
    feather.replace();
  }, [loading]);
  return (
    <>
      <SidebarProvider>
        <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
          <Header />
        </nav>

        <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
          <AdminSidebar />
        </div>
      </SidebarProvider>

      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <ProgressBar
            visible={true}
            height="80"
            width="80"
            color="#4fa94d"
            borderColor='green'
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <div className="flex flex-col min-h-screen mt-4">
          <div className="main-content flex-grow pt-16 pb-12">
            <div className="container-fluid px-[0.625rem] mt-10">
              <div className="grid grid-cols-1 mb-2">
                <div className="flex items-center justify-between">
                  <h4 className="mb-sm-0 text-xl font-semibold grow text-gray-800 ">
                    طرح های من
                  </h4>
                  <nav className="flex" aria-label="Breadcrumb"></nav>
                </div>
              </div>
              <h1 className="text-md mr-2">
                در این بخش، لیست طرح‌های ایجاد شده نمایش داده شده و امکان ویرایش آن‌ها وجود دارد.

              </h1>
            </div>
            {/* <div className="min-h-screen flex items-center justify-center p-2 col-span-12 xl:col-span-6 my-2">
                  <div className="w-full max-w-lg rtl "> */}
            <Plans plans={formData} />

            {/* </div>
                </div> */}
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}

